import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Stack,
  Box,
  Text,
  Image,
  useColorModeValue,
  FormErrorMessage,
  useToast,
} from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CustomInput from "components/common/customInput/CustomInput";
import { appRequest } from "routes";

const ResetPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .required("Password is required")
      .min(6, "Password must be 6 characters"),
    confirmPassword: Yup.string()
      .required("Confirm password is required")
      .oneOf([Yup.ref("password")], "Passwords must match"),
  });


export default function ResetPasswordForm() {
  const location = useLocation();
  const toast = useToast();
  const navigate = useNavigate();
  const [showError,setShowError]= useState(false)


  const handleSubmit = async (values: any, { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void }) => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");

    try {
      const response : any = await appRequest("auth", "resetPassword", {
        token: token,
        password: values.password,
        confirmPassword: values.confirmPassword,
      });

      if (response.status === "success") {
        toast({
          title: "Password Change Successfully successfully.",
          status: "success",
          duration: 9000,
          isClosable: true,
        });
        navigate("/login");
      } else {
        toast({
          title: "Password Change Failed.",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Account not created.",
        description: JSON.stringify(error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }

    setSubmitting(false);
  };

  return (
    <Flex
      minH={"100vh"}
      align={"center"}
      justify={"center"}
      bg={useColorModeValue("gray.50", "gray.800")}
    >
      <Stack spacing={2} mx={"auto"} w={"full"} maxW={"lg"} py={12} px={6}>
        <Stack align={"center"}>
          <Image src="/img/sequelstring.webp" width={320} />
        </Stack>
        <Formik
          initialValues={{
            password: "",
            confirmPassword: "",
          }}
          validationSchema={ResetPasswordSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, errors, values, handleChange }) => {
            console.log(errors)
            return(
            <Form>
                <Box
                  rounded={"lg"}
                  boxShadow={"lg"}
                  p={8}
                >
                  <Heading
                    color="teal.300"
                    fontSize={{ base: "2xl", md: "4xl" }}
                    fontWeight="700"
                    mb="11px"
                  >
                    Reset Password
                  </Heading>
                  <Stack spacing={4}>
                    <CustomInput
                      label="New Password"
                      type="password"
                      placeholder="Your new password"
                      name="password"
                      value={values.password}
                      error={errors.password}
                      showPassword={true}
                      showError={showError}
                      onChange={handleChange}
                    />
                    <CustomInput
                      label="Confirm Password"
                      type="password"
                      placeholder="Re-enter your new password"
                      name="confirmPassword"
                      showPassword={true}
                      error={errors.confirmPassword}
                      value={values.confirmPassword}
                      showError={showError}
                      onChange={handleChange}
                    />
                  </Stack>

                  <Stack spacing={6} mt={8}>
                    <Button
                      type="submit"
                      bg="teal.300"
                      color="white"
                      h={"45px"}
                      fontWeight="700"
                      isLoading={isSubmitting}
                      _hover={{
                        bg: "teal.400",
                      }}
                      onClick={() => {
                        setShowError(true)
                      }}
                    >
                      Submit
                    </Button>
                  </Stack>
                </Box>
            </Form>
          )}}
        </Formik>
      </Stack>
    </Flex>
  );
}
